import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import ServicesNav from './components/ServicesNav';
import ServicesHero from './components/ServicesHero';
import BomkalkulatorSection from './components/BomkalkulatorSection';
import RuteoptimaliseringSection from './components/RuteoptimaliseringSection';
import FlatestyringSection from './components/FlatestyringSection';
import ServicesCTA from './components/ServicesCTA';
import { ServicesDetailSkeleton } from '../../components/SkeletonLoader';

const ServicesDetail = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('bomkalkulator');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 950);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['bomkalkulator', 'ruteoptimalisering', 'flatestyring'];
      for (const id of sections) {
        const el = document.getElementById(id);
        if (el) {
          const rect = el?.getBoundingClientRect();
          if (rect?.top <= 120 && rect?.bottom >= 120) {
            setActiveTab(id);
            break;
          }
        }
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen" style={{ background: 'var(--color-background)', position: 'relative', overflow: 'hidden' }}>
      <Helmet>
        <title>Tjenester — Veiassistent</title>
        <meta name="description" content="Utforsk Veiassistents komplette tjenestepakke: Bomkalkulator, Ruteoptimalisering og Flåtestyring for privatpersoner og bedrifter." />
      </Helmet>
      {/* Architectural background geometry */}
      <div style={{ position: 'fixed', top: '-80px', right: '-80px', width: '500px', height: '500px', border: '1px solid rgba(255,87,34,0.04)', borderRadius: '2px', transform: 'rotate(18deg)', pointerEvents: 'none', zIndex: 0 }} />
      <div style={{ position: 'fixed', top: '30%', left: '-100px', width: '300px', height: '300px', border: '1px solid rgba(0,79,152,0.04)', borderRadius: '2px', transform: 'rotate(-12deg)', pointerEvents: 'none', zIndex: 0 }} />
      <div style={{ position: 'fixed', bottom: '10%', right: '-60px', width: '250px', height: '250px', border: '1px solid rgba(255,87,34,0.03)', borderRadius: '2px', transform: 'rotate(8deg)', pointerEvents: 'none', zIndex: 0 }} />
      <div style={{ position: 'fixed', top: '50%', left: '50%', width: '1px', height: '300px', background: 'rgba(255,87,34,0.03)', transform: 'rotate(30deg)', pointerEvents: 'none', zIndex: 0 }} />
      <ServicesNav />
      <main className="pt-[64px]" style={{ position: 'relative', zIndex: 1 }}>
        {isLoading ? (
          <ServicesDetailSkeleton />
        ) : (
          <>
            <ServicesHero activeTab={activeTab} onTabChange={setActiveTab} />
            <BomkalkulatorSection />
            <RuteoptimaliseringSection />
            <FlatestyringSection />
            <ServicesCTA />
          </>
        )}

        {/* Footer */}
        <footer style={{ padding: '40px 24px', borderTop: '1px solid rgba(224,228,232,0.06)', maxWidth: '1200px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ width: '24px', height: '24px', background: '#FF5722', borderRadius: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2.5"><polygon points="3 11 22 2 13 21 11 13 3 11" /></svg>
            </div>
            <span style={{ fontFamily: 'var(--font-heading)', fontSize: '14px', fontWeight: 700, color: 'var(--color-foreground)' }}>Veiassistent</span>
          </div>
          <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
            {[['Om oss', '/about-us'], ['Kontakt', '/contact'], ['Sikkerhet', '/trust-and-security'], ['FAQ', '/faq']]?.map(([label, path]) => (
              <button key={path} onClick={() => navigate(path)}
                style={{ background: 'none', border: 'none', fontFamily: 'var(--font-body)', fontSize: '13px', color: 'var(--color-muted-foreground)', cursor: 'pointer', padding: 0 }}
                onMouseEnter={e => e.currentTarget.style.color = 'var(--color-foreground)'}
                onMouseLeave={e => e.currentTarget.style.color = 'var(--color-muted-foreground)'}>
                {label}
              </button>
            ))}
          </div>
          <span style={{ fontFamily: 'var(--font-body)', fontSize: '12px', color: 'rgba(224,228,232,0.3)' }}>© 2024 Veiassistent AS</span>
        </footer>
      </main>
      <style>{`
        @media (max-width: 768px) {
          .services-grid { grid-template-columns: 1fr !important; }
          .specs-grid { grid-template-columns: 1fr 1fr !important; }
          .impl-grid { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 480px) {
          .specs-grid { grid-template-columns: 1fr !important; }
          .impl-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </div>
  );
};

export default ServicesDetail;
